import script from "./WorkspacesAffectMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspacesAffectMessage.vue?vue&type=script&setup=true&lang=js"

import "./WorkspacesAffectMessage.vue?vue&type=style&index=0&id=e9272586&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9272586"]])

export default __exports__